import React from "react";
import ContentLoader from "react-content-loader";
import { MainContent } from "./styles";
import { EntityListSkeleton } from "../../components/EntityListRow";
import {
  GoPeople,
  GoGraph,
  GoCalendar,
  GoSearch,
  GoArrowUp,
  GoLaw,
  GoDatabase,
  GoCreditCard,
  GoOrganization,
} from "react-icons/go";

const ClientsLoadingSkeleton = ({ isDark = true }) => {
  const backgroundColor = isDark ? "#1a1a1a" : "#f0f0f0";
  const foregroundColor = isDark ? "#2a2a2a" : "#e5e7eb";

  return (
    <>
      {/* KPI Cards - 3 principais */}
      <div className="kpi-cards main-stats">
        {[
          { icon: GoPeople, label: "Clientes Cadastrados" },
          { icon: GoGraph, label: "Faturamento Total" },
          { icon: GoCalendar, label: "Total de Impostos" },
        ].map((item, i) => (
          <div key={`kpi-${i}`} className={`kpi-card ${["primary", "success", "info"][i]}`}>
            <div className="card-content">
              <div className="thumb">
                <item.icon />
              </div>
              <div className="text">
                <p>
                  <ContentLoader
                    speed={2}
                    width={80}
                    height={20}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="4" ry="4" width="80" height="20" />
                  </ContentLoader>
                </p>
                <p>{item.label}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* KPI Cards - Impostos */}
      <div className="kpi-cards tax-stats">
        {[
          { icon: GoCalendar, label: "ICMS", className: "tax-icms" },
          { icon: GoLaw, label: "PIS/COFINS", className: "tax-piscofins" },
          { icon: GoOrganization, label: "IPI", className: "tax-ipi" },
          { icon: GoDatabase, label: "IBS", className: "tax-ibs" },
          { icon: GoCreditCard, label: "CBS", className: "tax-cbs" },
          { icon: GoGraph, label: "IS", className: "tax-is" },
        ].map((item, i) => (
          <div key={`tax-${i}`} className={`kpi-card compact ${item.className}`}>
            <div className="card-content">
              <div className="thumb">
                <item.icon />
              </div>
              <div className="text">
                <p>
                  <ContentLoader
                    speed={2}
                    width={70}
                    height={20}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="4" ry="4" width="70" height="20" />
                  </ContentLoader>
                </p>
                <p>{item.label}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Filtros */}
      <div className="filters">
        <div className="search-input-wrapper">
          <div className="search-icon">
            <GoSearch />
          </div>
          <ContentLoader
            speed={2}
            width={300}
            height={14}
            backgroundColor={backgroundColor}
            foregroundColor={foregroundColor}
            style={{ marginLeft: "40px" }}
          >
            <rect x="0" y="0" rx="3" ry="3" width="300" height="14" />
          </ContentLoader>
        </div>
      </div>

      {/* Conteúdo Principal */}
      <MainContent>
        {/* Lista de Clientes */}
        <div className="clients-table">
          {/* Header da Tabela */}
          <div className="table-header">
            <div className="header-cell cliente">Cliente</div>
            <div className="header-cell">Segmento</div>
            <div className="header-cell">UF</div>
            <div className="header-cell">Faturamento</div>
            <div className="header-cell">Impostos</div>
          </div>

          {/* Lista de Clientes - 10 rows */}
          <div className="table-body">
            <EntityListSkeleton
              rowCount={10}
              columns={[
                { width: "minmax(0, 2fr)" },
                { width: "minmax(0, 1fr)" },
                { width: "minmax(0, 1fr)" },
                { width: "minmax(0, 1fr)" },
                { width: "minmax(0, 1fr)" },
              ]}
            />
          </div>
        </div>

        {/* Card de Receita por Segmento */}
        <div className="segments-card">
          <div className="card-header">
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <h4 style={{ margin: 0 }}>Receita por Segmento de Clientes</h4>
              <span style={{ fontSize: '0.75em', opacity: 0.6, fontWeight: 400 }}>Participação percentual no faturamento</span>
            </div>
          </div>

          <div className="chart-section">
            <div style={{ 
              width: "200px", 
              height: "200px", 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "center" 
            }}>
              <div style={{
                width: "40px",
                height: "40px",
                border: "4px solid rgba(139, 92, 246, 0.2)",
                borderTop: "4px solid #8b5cf6",
                borderRadius: "50%",
                animation: "spin 1s linear infinite"
              }}></div>
            </div>
            <style>{`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}</style>
          </div>

          <div className="segments-list">
            {[...Array(5)].map((_, i) => (
              <div key={`segment-${i}`} className="segment-item">
                <div className="segment-header">
                  <div
                    className="segment-color"
                    style={{
                      backgroundColor: ["#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6"][i],
                    }}
                  />
                  <span className="segment-name">
                    <ContentLoader
                      speed={2}
                      width={100}
                      height={11}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="100" height="11" />
                    </ContentLoader>
                  </span>
                  <span className="segment-revenue">
                    <ContentLoader
                      speed={2}
                      width={80}
                      height={11}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="80" height="11" />
                    </ContentLoader>
                  </span>
                </div>
                <div className="segment-details">
                  <span className="segment-percentage" style={{ marginLeft: '18px' }}>
                    <ContentLoader
                      speed={2}
                      width={40}
                      height={10}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="40" height="10" />
                    </ContentLoader>
                  </span>
                </div>
                <div className="segment-bar">
                  <div
                    className="segment-progress"
                    style={{
                      width: `${100 - i * 18}%`,
                      backgroundColor: ["#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6"][i],
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </MainContent>

      {/* Análise Mensal */}
      <div className="monthly-chart">
        <div className="chart-header">
          <GoCalendar />
          <h4>Análise Mensal de Clientes</h4>
        </div>
        <div className="chart-content">
          <div className="month-info-card">
            <div className="month-info-header">
              <h5>
                <ContentLoader
                  speed={2}
                  width={100}
                  height={18}
                  backgroundColor={backgroundColor}
                  foregroundColor={foregroundColor}
                >
                  <rect x="0" y="0" rx="4" ry="4" width="100" height="18" />
                </ContentLoader>
              </h5>
              <span className="month-index">
                <ContentLoader
                  speed={2}
                  width={50}
                  height={12}
                  backgroundColor={backgroundColor}
                  foregroundColor={foregroundColor}
                >
                  <rect x="0" y="0" rx="3" ry="3" width="50" height="12" />
                </ContentLoader>
              </span>
            </div>
            <div className="month-metrics">
              {["novos", "ativos", "faturamento"].map((type, i) => (
                <div key={type} className={`metric-item ${type}`}>
                  {type === "novos" && <GoArrowUp className="metric-icon" />}
                  {type === "ativos" && <GoPeople className="metric-icon" />}
                  {type === "faturamento" && <GoGraph className="metric-icon" />}
                  <div className="metric-content">
                    <span className="metric-label">
                      {type === "novos" ? "Novos Clientes" : type === "ativos" ? "Clientes Ativos" : "Faturamento"}
                    </span>
                    <span className="metric-value">
                      <ContentLoader
                        speed={2}
                        width={100}
                        height={16}
                        backgroundColor={backgroundColor}
                        foregroundColor={foregroundColor}
                      >
                        <rect x="0" y="0" rx="3" ry="3" width="100" height="16" />
                      </ContentLoader>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="chart-container">
            <div className="chart-header-bar">
              <h4>Evolução Mensal</h4>
              <div className="chart-legend">
                <div className="legend-item">
                  <div className="legend-color" style={{ backgroundColor: "#3b82f6" }}></div>
                  <span>Novos</span>
                </div>
                <div className="legend-item">
                  <div className="legend-color" style={{ backgroundColor: "#10b981" }}></div>
                  <span>Ativos</span>
                </div>
              </div>
            </div>
            <div style={{ height: "380px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <ContentLoader
                speed={2}
                width={600}
                height={300}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                {/* Barras do gráfico simuladas */}
                {[...Array(12)].map((_, i) => {
                  const x = 20 + i * 48;
                  const heights = [180, 220, 160, 240, 200, 190, 210, 170, 230, 195, 215, 185];
                  return (
                    <g key={i}>
                      <rect x={x} y={300 - heights[i]} rx="3" ry="3" width="18" height={heights[i]} />
                      <rect x={x + 22} y={300 - heights[i] * 0.85} rx="3" ry="3" width="18" height={heights[i] * 0.85} />
                    </g>
                  );
                })}
              </ContentLoader>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientsLoadingSkeleton;
